import { RawLink } from '@/shared/ui/RawLink'
import { Box, Typography, useTheme } from '@mui/material'
import { TopMenuButtonProps } from '@/types/topmenu/TopMenuButton'
import { useLocation } from 'react-router-dom'
import { useAppStore } from '../store'

const TopMenuButton = ({
    onClickFunction,
    buttonText,
    buttonIcon,
    active,
    destination,
    isDisabled,
    customIconStyle,
}: TopMenuButtonProps) => {
    const theme = useTheme()

    const { setPreviousPage } = useAppStore()
    const location = useLocation()

    const handleButtonClick = () => {
        onClickFunction()
        setPreviousPage(location.pathname)
    }

    const buttonStyle = {
        maxWidth: '86px',
        width: { xs: '100%', md: '100vw' },
        height: '34px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '20px',
        '&:hover': { cursor: !isDisabled ? 'pointer' : 'default' },
    }

    const iconStyle = {
        display: 'inline',

        filter: () =>
            active && !isDisabled
                ? 'brightness(0) saturate(100%) invert(59%) sepia(85%) saturate(4319%) hue-rotate(325deg) brightness(98%) contrast(95%)'
                : 'none',
    }

    const typographyStyle = {
        typography: 'label4',
        color: () =>
            active && !isDisabled ? `${theme.palette.primary.main}` : 'none',
    }

    return (
        <RawLink to={destination} isDisabled={isDisabled}>
            <Box
                data-testid="top-menu-button"
                sx={buttonStyle}
                onClick={() => {
                    if (!isDisabled) handleButtonClick()
                }}>
                <Box sx={{ ...iconStyle, ...customIconStyle }}>
                    {buttonIcon}
                </Box>
                <Typography component="span" sx={typographyStyle} color="white">
                    {buttonText}
                </Typography>
            </Box>
        </RawLink>
    )
}

export { TopMenuButton }
